module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_XII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("Thanks are due first to Ruth McCurry of SPCK for her help and encouragement at every stage in the writing, editing and production of this book, and particularly for her patience as the completion date kept receding.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("Various scholars have kindly read and commented on draft chapters: Professor Rick Hess of Denver Seminary; Professors Iain Provan and Phil Long of Regent College, Vancouver; Dr Walter McConnell of Singapore Bible College. Their help is gratefully acknowledged.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("Three classes of students at the Biblical Graduate School of Theology, Singapore, have read and commented on draft chapters of this book. Many thanks to them as well.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("All biblical quotations in this book, as noted above, are taken from the New Revised Standard Version (Anglicized Edition) (Oxford University Press, 1995) unless otherwise stated. Permission to quote from this version is gratefully acknowledged.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("Inter-Varsity Press allowed us to reproduce the maps in Chapters 2, 3, 5, 6 and 9.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("These maps are taken from pp. 35, 42, 45, 90, 91 and 94 of J.J. Bimson and J.P. Kane (eds), "), _c('i', [_vm._v("New Bible Atlas ")]), _vm._v("(Leicester: IVP, 1985). Professor Kenneth Kitchen kindly consented to our reproducing the table representing the chronology of the judges period in Chapter 4. This table is taken from his "), _c('i', [_vm._v("On the Reliability of the Old Testament ")]), _vm._v("(Grand Rapids: Eerdmans, 2003), p. 210. We are grateful to Inter-Varsity Press and to Professor Kitchen.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("Philip Satterthwaite began work on this book towards the end of his period as Research Fellow in Hebrew and Aramaic at Tyndale House, Cambridge, and the Oriental Studies Faculty, Cambridge, a post which he held from 1993 to 1998. He would like to thank Sir Kirby Laing and his foundation, who provided the funding for the fellowship.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XII"
    }
  }, [_vm._v("He also records his thanks to the Council and Faculty of the Biblical Graduate School of Theology, Singapore, for granting him two periods of sabbatical leave in 2002 and 2006, without which the book could not have been completed.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 78
// module chunks = 0